import { Box, BoxProps, Text, VisuallyHidden } from "@biblioteksentralen/react";
import { useCountDown } from "../campaigns/useCountDown";
import { ResolvedSommerlesBannerData } from "@libry-content/common";
import { getContainerQuery } from "../site/banners/promotedItems/utils";

const countdownPlacements = [
  {
    top: { base: "65%", sm: "65%" },
    left: "20%",
  },
  {
    top: { base: "30%", sm: "37%" },
    left: "40%",
  },
  {
    top: { base: "73%", sm: "65%" },
    left: "60%",
  },
  {
    top: "37%",
    left: "80%",
  },
] satisfies BoxProps[];

type Props = {
  sommerles: ResolvedSommerlesBannerData;
  smallScreen: boolean;
};

export const Countdown = ({ sommerles, smallScreen }: Props) => {
  const detail = sommerles?.templateContent?.detail1;
  const countdownTo = sommerles?.startDate
    ? new Date(`${new Date().getFullYear()}-${sommerles?.startDate}T00:00:00`)
    : undefined;

  const timeFragments = useCountDown(countdownTo, { smallScreen });

  if (!sommerles?.startDate || !detail) return null;

  const reversedFragments = timeFragments.slice(0, 4).reverse();

  return (
    <Box
      position="relative"
      fontSize="clamp(.6em, 2.5vw, 1.25em)"
      css={getContainerQuery({ base: { width: "100%" }, md: { width: "75%" } })}
      textAlign="center"
      height="50%"
    >
      <VisuallyHidden aria-live="polite" aria-atomic aria-relevant="all">
        {reversedFragments
          .slice(0, 3)
          .map(([amount, unit]) => `${amount} ${unit}`)
          .join(", ")}
      </VisuallyHidden>
      <Box aria-hidden>
        {reversedFragments.map(([amount, unit], index) => (
          <Box
            key={index}
            color="#F3BA6A"
            WebkitTextStroke="3px #8E0F0F"
            paintOrder="stroke fill"
            fontWeight={400}
            fontSize={{ base: "3.5em", sm: "3em", md: "2em" }}
            position="absolute"
            alignItems="center"
            lineHeight={1}
            textAlign="center"
            transform="translate(-50%, -50%)"
            {...countdownPlacements[index]}
          >
            <Text>{amount}</Text>
            <Text fontSize={{ base: "0.5em" }}>{unit}</Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
